import SvgIcon, { SvgIconProps } from "@mui/material/SvgIcon";

function Github(props: SvgIconProps) {
	return (
		<SvgIcon viewBox="0 0 32 32" {...props}>
			<path d="M17 17H27V27H17V17Z" fill="#FEBA08" />
			<path d="M5 17H15V27H5V17Z" fill="#05A6F0" />
			<path d="M17 5H27V15H17V5Z" fill="#80BC06" />
			<path d="M5 5H15V15H5V5Z" fill="#F25325" />
		</SvgIcon>
	);
}

export default Github;
